
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 5h20v16h-9.656l-4.719 3.781L6 26.094V21H2V5zm2 2v12h4v2.906l3.375-2.688.281-.219H20v-12H4zm20 2h6v16h-4v5.094L19.656 25h-9.313l2.5-2h7.5l3.656 2.906V23h4V11h-4V9z"}})])
          )
        }
      }
    